var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEraser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.5,
    height: 19.369,
    viewBox: "0 0 20.5 19.369",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fff;stroke:#fff;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-135.012 -14.122)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M169.408,28.954l3.889-3.889a1.505,1.505,0,0,0,0-2.125l-4.13-4.13a1.509,1.509,0,0,0-2.125,0l-3.89,3.889Z",
    transform: "translate(-19.827 -2.979)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M150.056,48.3l3.889-3.889-6.255-6.255L143.8,42.046a1.505,1.505,0,0,0,0,2.126l4.13,4.13A1.5,1.5,0,0,0,150.056,48.3Z",
    transform: "translate(-6.032 -16.822)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M154.726,32.17h-9.532l.023-.02,4.083-4.083,4.84-4.84a2.652,2.652,0,0,0,0-3.746L149.8,15.145a2.655,2.655,0,0,0-3.746,0l-4.84,4.84-4.083,4.083a2.655,2.655,0,0,0,0,3.746l4.335,4.335.023.02H135.8a.536.536,0,1,0,0,1.071h18.929a.536.536,0,1,0,0-1.071Zm-6.8-16.726a1.566,1.566,0,0,1,1.115.459l4.335,4.335a1.58,1.58,0,0,1,0,2.231L149.3,26.552l-6.566-6.566,4.083-4.083A1.565,1.565,0,0,1,147.931,15.443ZM137.893,27.057a1.58,1.58,0,0,1,0-2.231l4.083-4.083,6.566,6.566-4.083,4.083a1.579,1.579,0,0,1-2.231,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraser);
export default __webpack_public_path__ + "static/media/eraser.70543f4a235594f37b43c55e6b180b06.svg";
export { ForwardRef as ReactComponent };